var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import { ofType } from "redux-observable";
import { concat, from, of } from "rxjs";
import { mapTo, switchMap, take } from "rxjs/operators";
import { IdDefaultThreshold } from "../../../../constants/IdDefaultThreshold";
import { IdResource } from "../../../../constants/IdResource";
import { selectAndApplyActiveBuildingBuffedCost } from "../../../../selectors/selectBuffsInfo";
import { selectBuildingUpgradeInfo } from "../../../../selectors/selectExistingBuildingInfo";
import { actionModalOpen } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { actionOngoingPurchasePremiumSelect } from "../../../ongoing-purchase/actionOngoingPurchase";
import { TypeActionSpendGoldConfirmation } from "../../../spend-gold-confirmation/actionSpendGoldConfirmation";
import { actionBuildingUpgradeConfirmed, TypeActionBuildings, } from "../actionBuildings";
export var epicBuildingUpgradeConfirmationRequest = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionBuildings.UpgradeConfirmationRequest), switchMap(function (action) {
        if (!action.premium) {
            return of(actionBuildingUpgradeConfirmed(action.building, action.premium));
        }
        var upgradeInfo = selectBuildingUpgradeInfo(action.building);
        var next = upgradeInfo.nextStage;
        var premiumCost = next.premium.cost.find(function (cost) { return cost.resourceId === IdResource.Gold; });
        var premiumAmount = selectAndApplyActiveBuildingBuffedCost(state$.value, action.building.balancing.id, IdResource.Gold, premiumCost.amount);
        var purchasePremiumInfo = {
            goldAmount: Long.fromValue(premiumAmount),
            isConfirmed: false,
        };
        if (premiumAmount < IdDefaultThreshold.GoldSpendConfirmAmount) {
            return from([
                actionOngoingPurchasePremiumSelect(__assign({}, purchasePremiumInfo, { isConfirmed: true })),
                actionBuildingUpgradeConfirmed(action.building, action.premium),
            ]);
        }
        return concat(from([
            actionOngoingPurchasePremiumSelect(purchasePremiumInfo),
            actionModalOpen(IdModal.SpendGoldConfirmation),
        ]), action$.pipe(ofType(TypeActionSpendGoldConfirmation.Finish), take(1), mapTo(actionBuildingUpgradeConfirmed(action.building, action.premium))));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/epics/epicBuildingUpgradeConfirmationRequest.ts
// module id = 2092
// module chunks = 3